module.exports = __webpack_public_path__ + "static/young-adults-2cc53111b5597d886841857519416734.jpg";